var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.295 229.534C17.546 287.159 63.142 333.347 120.458 347.223C135.927 351.004 151.522 352.441 166.585 351.691L103.394 427.505C92.081 441.099 93.925 461.286 107.488 472.599C121.145 483.88 141.271 482.068 152.585 468.505L275.435 321.066C304.187 286.566 320 242.846 320 197.939C320 108.626 250.059 34.219 164.116 32.031C162.71 32 161.366 32 159.96 32C111.676 32 66.674 53.282 36.016 90.844C4.451 129.47 -7.112 180.033 4.295 229.534ZM159.991 96.001C213.014 96.001 255.996 138.982 255.996 192.002S213.014 288.003 159.991 288.003S63.986 245.022 63.986 192.002S106.969 96.001 159.991 96.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.e642110dd00a238adcebda3ed0f6fbfb.svg";
export { ForwardRef as ReactComponent };